import type { RouteRecordRaw } from 'vue-router';

export const inboxRoute: RouteRecordRaw = {
  path: '/inbox',
  name: 'Inbox',
  component: () => import('./pages/InboxPage.vue'),
  meta: {
    title: 'Inbox',
    layout: 'main',
    authorize: ({ isGranted }) => isGranted('dt:core:notifications:list'),
  },
};
